import { createFileRoute } from "@tanstack/react-router";
import { ensureSourcingEnabled } from "@/features/sourcing/stage";
import { ListsIndex } from "@/features/sourcing/ListsIndex";

export const Route = createFileRoute("/_auth/_agents/sourcing/")({
  beforeLoad: ({ context, preload }) => ensureSourcingEnabled(context.queryClient, preload),
  component: ListsIndex,
});
